/* eslint-disable */
export default {

  init() {
    // JavaScript to be fired on all pages








  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired


    $(document).on('ready', function () {

      // initialization of slick carousel

    // initialization of popups
      $.DVCore.components.DVFancyBox.init('.js-fancybox');

    // initialization of go to
    $.DVCore.components.DVGoTo.init('.js-go-to');

    // initialization of video player
    $.DVCore.components.DVVideoPlayer.init('.js-inline-video-player');

      // initialization of hamburgers
      $.DVCore.components.DVHamburgers.init('#hamburgerTrigger');
      // initialization of popups
      $.DVCore.components.DVModalWindow.init('[data-modal-target]');

      // initialization of autonomous popups
      $.DVCore.components.DVModalWindow.init('.js-modal-window', {
        autonomous: true
      });





      // initialization of unfold component
      $.DVCore.components.DVUnfold.init($('[data-unfold-target]'), {
        beforeClose: function () {
          $('#hamburgerTrigger').removeClass('is-active');
        },
        afterClose: function() {
          $('#headerSidebarList .collapse.show').collapse('hide');
        }
      });

      $('#headerSidebarList [data-toggle="collapse"]').on('click', function (e) {
        e.preventDefault();

        var target = $(this).data('target');

        if($(this).attr('aria-expanded') === "true") {
          $(target).collapse('hide');
        } else {
          $(target).collapse('show');
        }
      });


    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js